module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "help-block text-center"
  }, [(_vm.successfulVer == true) ? _c('span', [_vm._v(_vm._s(_vm.$t('pages.confirmEmail.success')))]) : _vm._e(), _vm._v(" "), (_vm.successfulVer == false) ? _c('span', [_vm._v(_vm._s(_vm.$t('pages.confirmEmail.fail')))]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0e58cacb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e58cacb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/authentication/ConfirmEmail.vue
// module id = 1383
// module chunks = 1